class CartRecommendations extends HTMLElement {
  #loaded = false;

  connectedCallback() {
    if (this.#loaded) {
      return;
    }

    this.#loaded = true;
    this.#load();
  }

  async #load() {
    const productId = this.getAttribute('product');

    if (!productId) {
      return this.replaceChildren();
    }

    const limit = this.getAttribute('limit') || 4;
    const sectionId = this.getAttribute('section');

    for (const intent of ['complementary', 'related']) {
      const url = `${Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${sectionId}&intent=${intent}`;

      try {
        const response = await fetch(url, { priority: 'low' });

        if (!response.ok) {
          continue;
        }

        const document_ = new DOMParser().parseFromString(await response.text(), 'text/html'),
          recommendations = document_.querySelector('cart-recommendations');

        if (recommendations && recommendations.childElementCount > 0) {
          return this.replaceChildren(...document.importNode(recommendations, true).childNodes);
        }
      } catch {}
    }

    this.replaceChildren();
  }
}

if (!window.customElements.get('cart-recommendations')) {
  window.customElements.define('cart-recommendations', CartRecommendations);
}

class UpsellVariantSelect extends HTMLElement {
  connectedCallback() {
    this.querySelector('select')?.addEventListener('change', this.#onVariantChanged.bind(this));
  }

  #onVariantChanged(event) {
    const tile = this.closest('.horizontal-product') ?? this;

    tile.querySelectorAll('[data-variant-price]').forEach((price) => {
      price.hidden = price.getAttribute('data-variant-price') !== event.target.value;
    });

    tile.querySelectorAll('[data-variant-title]').forEach((title) => {
      title.hidden = title.getAttribute('data-variant-title') !== event.target.value;
    });
  }
}

if (!window.customElements.get('upsell-variant-select')) {
  window.customElements.define('upsell-variant-select', UpsellVariantSelect);
}
